import { render } from "./FacturaEstadoVerificacion.vue?vue&type=template&id=24b5c0ee&scoped=true"
import script from "./FacturaEstadoVerificacion.vue?vue&type=script&lang=js"
export * from "./FacturaEstadoVerificacion.vue?vue&type=script&lang=js"

import "./FacturaEstadoVerificacion.vue?vue&type=style&index=0&id=24b5c0ee&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5c0ee"]])

export default __exports__